// extracted by mini-css-extract-plugin
export var downArrow = "_96-0";
export var infoTooltipIcon = "_96-3";
export var label = "_96-1";
export var optionCard = "_96-4";
export var upArrow = "_96-2";